function Data<T>({
  loading,
  whenLoading,
  data,
  whenEmpty,
  isEmpty,
  children,
}: {
  data: T | null | undefined
  loading: boolean
  whenLoading?: React.ReactElement
  whenEmpty?: React.ReactElement
  isEmpty?: (data: T | null | undefined) => boolean
  children: (props: NonNullable<T>) => React.ReactElement
}) {
  if (loading) {
    return whenLoading || <div>Loading...</div>
  } else if (!data || isEmpty?.call(undefined, data)) {
    return whenEmpty || <div>Oops, no data</div>
  } else {
    return children(data!)
  }
}

export default Data
